import script from "./region.vue?vue&type=script&setup=true&lang=ts"
export * from "./region.vue?vue&type=script&setup=true&lang=ts"

import "./region.vue?vue&type=style&index=0&id=66281f68&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66281f68"]])

export default __exports__